"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalaryRateButtons = exports.InputMinMax = exports.StyledSlider = void 0;
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.StyledSlider = (0, styled_components_1.default)(antd_1.Slider) `
	margin: 1rem 6px;

	&& {
		.ant-slider-dot {
			height: 14px;
			width: 14px;
			top: -4px;
		}
		.ant-slider-handle {
			height: 20px;
			width: 20px;
			margin-top: -7px;
		}
		.ant-slider-rail {
			height: 6px;
		}
		.ant-slider-track {
			height: 6px;
		}
		.ant-slider-mark-text {
			margin-top: 5px;
		}
	}
`;
exports.InputMinMax = (0, styled_components_1.default)(elements_1.InputNumber) `
	width: 110px;
`;
exports.SalaryRateButtons = (0, styled_components_1.default)(elements_1.SwitchButtonsGroup) `
	${(0, styled_breakpoints_1.down)('xs')} {
		.ant-btn {
			font-size: 13px;
			padding: 4px 12px;
		}
	}
`;
